<script>
export default {
  name: 'TreeNode',
  props: {
    nodeKey: { type: [String, Number], required: false },
    nodeVal: { required: true },
    path: { type: String, required: true },
    search: { type: String, default: '' },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    isObject() { return this.nodeVal && typeof this.nodeVal === 'object' && !Array.isArray(this.nodeVal); },
    isArray() { return Array.isArray(this.nodeVal); },
    isLeaf() { return !this.isObject && !this.isArray; },
    keys() { return this.isObject ? Object.keys(this.nodeVal) : []; },
    sizeLabel() {
      if (this.isArray) return `[${this.nodeVal.length}]`;
      if (this.isObject) return `{${Object.keys(this.nodeVal).length}}`;
      return '';
    },
    matches() {
      const q = this.search?.toLowerCase();
      if (!q) return true;
      const keyHit = this.nodeKey !== undefined && String(this.nodeKey).toLowerCase().includes(q);
      if (this.isLeaf) {
        const valHit = String(this.nodeVal).toLowerCase().includes(q);
        return keyHit || valHit;
      }
      // container stays visible so children can be toggled
      return true;
    }
  },
  methods: {
    async copy(text) {
      const toCopy = String(text ?? '');
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(toCopy);
          return;
        }
      } catch (e) {
        // clipboard API not available; fallback below
      }
      try {
        const ta = document.createElement('textarea');
        ta.value = toCopy;
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (err) {
        console.error('Copy to clipboard failed:', err);
      }
    },
    formatVal(v) {
      if (typeof v === 'string') return `"${v}"`;
      if (typeof v === 'number' || typeof v === 'boolean') return String(v);
      if (v === null) return 'null';
      return '';
    }
  }
}
</script>

<template>
  <div v-show="matches" class="tree-node">
    <div class="d-flex align-items-center">
      <button v-if="!isLeaf" class="btn btn-sm btn-link p-0 me-1" @click="expanded = !expanded">
        <i :class="expanded ? 'uil uil-minus-square' : 'uil uil-plus-square'"></i>
      </button>
      <span class="fw-bold" v-if="nodeKey !== undefined">{{ nodeKey }}</span>
      <span class="text-muted ms-1" v-if="!isLeaf">{{ sizeLabel }}</span>
      <span class="ms-2" v-if="isLeaf">{{ formatVal(nodeVal) }}</span>
<!--      <div class="ms-auto">-->
<!--        <button class="btn btn-sm btn-outline-secondary me-1" title="Copy path" @click="copy(path)"><i class="uil uil-link"></i></button>-->
<!--        <button class="btn btn-sm btn-outline-secondary" title="Copy value" v-if="isLeaf" @click="copy(nodeVal)"><i class="uil uil-copy"></i></button>-->
<!--      </div>-->
    </div>
    <div v-if="expanded && isObject" class="ms-3 border-start ps-2 mt-1">
      <TreeNode v-for="k in keys" :key="k" :node-key="k" :node-val="nodeVal[k]" :path="path + '.' + k" :search="search" />
    </div>
    <div v-if="expanded && isArray" class="ms-3 border-start ps-2 mt-1">
      <TreeNode v-for="(item, idx) in nodeVal" :key="idx" :node-key="idx" :node-val="item" :path="path + '[' + idx + ']'" :search="search" />
    </div>
  </div>
</template>

<style scoped>
</style>


